// src/components/Header.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Header = () => {
  const { t } = useTranslation();

  return (
    <header className="text-center py-4 px-5 bg-[#1a365d] text-white shadow-md">
      <nav className="mb-4 space-x-4 text-sm flex flex-wrap justify-center items-center gap-y-2">
        <Link to="/" className="hover:text-blue-200 transition">{t('home')}</Link>
        <Link to="/about" className="hover:text-blue-200 transition">{t('about')}</Link>
        <Link to="/pricing" className="hover:text-blue-200 transition">{t('pricing')}</Link>
        <Link to="/leaderlab" className="hover:text-blue-200 transition">{t('leaderlab', 'Leader Lab')}</Link>
        <Link to="/lexicon" className="hover:text-blue-200 transition">{t('lexicon')}</Link>
        
        {/* --- DASHBOARD & PARTNER LINKS --- */}
        <div className="inline-block border-l border-blue-400 pl-4 ml-2 space-x-4">
            <Link to="/my-dashboard" className="hover:text-yellow-300 transition font-bold text-yellow-400">
              {t('student', 'Student')}
            </Link>

            <Link to="/teacher-dashboard" className="hover:text-yellow-300 transition font-semibold">{t('teacher', 'Teacher Room')}</Link>
            <Link to="/partner-dashboard" className="hover:text-yellow-300 transition font-semibold">Partners</Link>
            
            {/* Investment Links Group */}
            <div className="inline-flex gap-3">
              <Link to="/investment" className="hover:text-yellow-300 transition font-semibold">Community Fund</Link>
              <Link to="/borealis" className="text-cyan-300 hover:text-cyan-100 font-bold transition flex items-center gap-1">
                 <span className="text-xs">❄️</span> Borealis
              </Link>
            </div>
        </div>

        {/* --- DISCORD GUILD LINK --- */}
        <div className="inline-block border-l border-blue-400 pl-4 ml-2">
             <a href="https://discord.gg/BDatnMHH8j" target="_blank" rel="noopener noreferrer" className="hover:text-[#5865F2] font-bold transition flex items-center gap-1">
                <span className="text-lg">🏛️</span> Guild
             </a>
        </div>

        {/* --- AUTH BUTTONS --- */}
        <div className="inline-block border-l border-blue-400 pl-4 ml-2 space-x-4">
            <Link to="/login" className="bg-blue-600 px-3 py-1 rounded hover:bg-blue-700 transition">{t('login', 'Login')}</Link>
            <Link to="/signup" className="bg-green-600 px-3 py-1 rounded hover:bg-green-700 transition">{t('signup', 'Sign Up')}</Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;